export const normalizeFormData = (data: any): any => {

    if (data === "" || data === undefined || data === null) return null;


    if (Array.isArray(data)) {

        const cleanedArray = data
            .map(normalizeFormData)
            .filter(item => item !== null);


        return cleanedArray.length === 0 ? null : cleanedArray;
    }


    if (data instanceof Date) return data.toISOString();
    if (data && typeof data === 'object' && typeof data.format === 'function') {
        return data.toISOString();
    }


    if (typeof data === "object" && data !== null) {
        const cleaned: Record<string, any> = {};

        Object.keys(data).forEach(key => {
            const value = normalizeFormData(data[key]);


            if (value !== null) {
                cleaned[key] = value;
            }
        });


        if (Object.keys(cleaned).length === 0) return null;

        return cleaned;
    }


    if (typeof data === "string") {
        const trimmed = data.trim();
        return trimmed === "" ? null : trimmed;
    }


    return data;
};